import * as Constants from './Constants';

const initialState = {
  isCartVisible: true,
  contactBillingInfo: '',
  editContactInfo: '',
  billingInfo: '',
  contactCtaValue: false,
  billingCtaValue: false,
  // securePinCtaValue: null,
  isUpdateInfoSuccess: false,
  contactInfoEditResponse: '',
  updateShippingAdressResponse: '',
  contactFormInfo: '',
  billingFormInfo: '',
  securePinFormInfo: '',
  contactInfoEditError: '',
  billingAddressError: false,
  isInvalidZipcodeError: false,
  marketDetails: [],
  showContactPageError: false,
  serviceinfo: null,
  accMainEmailVal: null,
  contactInvalidCaseError: false,
  contactContinueCtaValue: false,
  isAALContactInfoUpdated: false,
  emailMaxAttempts: false,
  isUpdateIspuInfoFlag: false,
  contactInfoError: false,
  contactInfoNtfyMsg: null,
  isUniversalProfileSuccessBannerDisplayed: false,
  isUniversalProfileCreated: false,
  password: '',
  emailAPiResponse: {},
  phoneAPiResponse: {},
  universalProfileCreationStatus: '',
  universalProfileCreationBannerMessages: {},
  passwordValidationFailed: false,
  isPasswordRulesCheckboxChecked: false,
  isNonVzConsentCheckboxChecked: false,
  showTermsandConditionsBanner: false,
  previousEmail: '',
  blackListedPasswordDetails: {
    containsList: [],
    exactList: [],
  },
  isCradleSuccess: false,
  encEmail: '',
  showEmailExistBanner: false,
  isSeqUPICompleted: '',
  isConInfoEdited: false,
  cradleThrottleList: '',
  latestSuccessfullyVerifiedEmail: '',
  cartContactCTADisabled: false,
  billingAddress2UnitItems: 0,
  billingAddress2UnitArray: [],
};

function contactInfo(state = initialState, action) {
  switch (action.type) {
    case Constants.GET_CONTACT_INFO_SUCCESS:
      return { ...state, contactBillingInfo: action.response && action.response };
    case Constants.EDIT_LINK:
      return { ...state, editContactInfo: action.data && action.data };
    case Constants.UPDATE_SHOW_CART:
      return { ...state, isCartVisible: action.data && action.data };
    case 'SPL_OFFER_FLAG':
      return { ...state, splFlag: action.data && action.data };
    case 'BILLING_FORM_VALUES':
      return { ...state, billingFormInfo: action.data && action.data };
    case 'CONTACT_FORM_VALUES':
      return { ...state, contactFormInfo: action.data && action.data };
    case 'SECURE_PIN_FORM_VALUES':
      return { ...state, securePinFormInfo: action.data && action.data };
    case 'CITY_AND_STATE_SUCCESS':
      return { ...state, marketDetails: action.response, isInvalidZipcodeError: false };
    case 'INVALID_ZIP_CODE':
      return { ...state, isInvalidZipcodeError: true, marketDetails: [] };
    case 'BILLING_ADDRESS1_CTA_VALUES':
      return { ...state, billingAddress1CtaValue: action.data && action.data };
    case 'BILLING_ADDRESS2_CTA_VALUES':
      return { ...state, billingAddress2CtaValue: action.data && action.data };
    case 'BILLING_ZIPCODE_CTA_VALUES':
      return { ...state, billingZipcodeCtaValue: action.data && action.data };
    case 'CONTACT_FNAME_CTA_VALUES':
      return { ...state, contactFnameCtaValue: action.data && action.data };
    case 'CONTACT_CONTINUE_CTA_VALUES':
      return { ...state, contactContinueCtaValue: action.data && action.data };
    case 'CONTACT_LNAME_CTA_VALUES':
      return { ...state, contactLnameCtaValue: action.data && action.data };
    case 'CONTACT_EMAIL_CTA_VALUES':
      return { ...state, contactEmailCtaValue: action.data && action.data };
    case 'CONTACT_PHONE_CTA_VALUES':
      return { ...state, contactPhoneCtaValue: action.data && action.data };
    case 'SECURE_PIN_CTA_VALUES':
      return { ...state, securePinCtaValue: action.data && action.data };
    case 'SECURE_CONFIRM_PIN_CTA_VALUES':
      return { ...state, secureConfirmPinCtaValue: action.data && action.data };
    case 'BILLING_OPTION_CHANGE':
      return { ...state, billingInfoEdited: action.data && action.data };
    case 'POST_NSE_DATA_RESPONSE':
      return { ...state, response: action.response };
    case 'BILLING_ADDRESS2_UNIT_ITEMS':
      return { ...state, billingAddress2UnitItems: action.data && action.data };
    case 'BILLING_ADDRESS2_UNIT_ARRAY':
      return { ...state, billingAddress2UnitArray: action.data && action.data };
    case Constants.IS_UPDATE_INFO_SUCCESS:
      return { ...state, isUpdateInfoSuccess: action.response };
    case Constants.IS_UPDATE_ISPU_CONTACT_INFO_SUCCESS:
      return { ...state, isUpdateIspuInfoFlag: action.response };
    case Constants.CONTACT_INFO_EDIT_RESPONSE:
      return { ...state, contactInfoEditResponse: action.data && action.data };
    case 'EMAIL_VALIDATION':
      return {
        ...state,
        emailAPiResponse: action.response,
        accMainEmailVal: action.response.accMainEmailVal,
        encEmail: action.response?.amValidationResponse?.encEmail,
      };
    case 'EMAIL_VALIDATION_CLEAR':
      return {
        ...state,
        emailAPiResponse: null,
      };
    case 'PHONE_VALIDATION':
      return {
        ...state,
        phoneAPiResponse: action.response,
      };
    case Constants.UPDATE_SHIPPING_ADDRESS_SUCCESS:
      return { ...state, updateShippingAdressResponse: action.response };
    case Constants.CONTACT_INFO_EDIT_ERROR:
      return { ...state, contactInfoEditError: action.data && action.data };
    case 'BILLING_ADDRESS1_ERROR':
      return { ...state, billingAddressError: action.response };
    case 'BILLING_ADDRESS1_ERROR_RELOAD':
      return { ...state, billingAddressError: false };
    case 'UPDATE_PERSONAL_API_FAIL':
      return { ...state, showContactPageError: action.response, serviceinfo: action.serviceinfo };
    case 'CLEAR_PERSONAL_API_ERROR':
      return { ...state, showContactPageError: false, serviceinfo: action.serviceinfo };
    case Constants.CONTACT_FETCH_SMS_DEVICES_SUCCESS:
      return {
        ...state,
        securePinDataDeviceSucess: action.response,
        isInvalidOTP: false,
        ...action.commonData,
      };
    case Constants.CONTACT_GET_DATA_SUCCESS:
      return { ...state, title: action.response && action.response.data };
    case Constants.CONTACT_GET_ENABLED_DEVICES_SUCCESS:
      return { ...state, securePinData: action.response };
    case Constants.ACC_MAIN_EMAIL_VALIDATION:
      return { ...state, accMainEmailVal: action.response };
    case Constants.CI_INVALID_CASE_ERROR:
      return { ...state, contactInvalidCaseError: action.response, serviceinfo: action.serviceinfo };
    case 'UPDATE_CONTACT_INFO_COMPLETED':
      return { ...state, isAALContactInfoUpdated: true };
    case 'EMAIL_MAX_ATTEMPTS':
      return { ...state, emailMaxAttempts: action.response };
    case Constants.CEF_CONTACT_INFO_ERROR:
      return { ...state, contactInfoError: action.response, contactInfoNtfyMsg: action.errorMessage };
    case Constants.CREATE_UNIVERSAL_PROFILE_SUCCESS:
      return { ...state, isUniversalProfileCreated: true, universalProfileCreationStatus: 'success' };
    case Constants.CREATE_UNIVERSAL_PROFILE_FAILURE:
      return { ...state, isUniversalProfileCreated: false, universalProfileCreationStatus: 'error' };
    case Constants.UNIVERSAL_PROFILE_BANNER_MESSAGES:
      return { ...state, universalProfileCreationBannerMessages: action.payload };
    case Constants.CREATE_UNIVERSAL_PROFILE_SUCCES_TOGGLE:
      return { ...state, isUniversalProfileCreated: false };
    case Constants.UNIVERSAL_PROFILE_BANNER_DISPLAYED:
      return { ...state, isUniversalProfileSuccessBannerDisplayed: true, universalProfileCreationStatus: '' };
    case Constants.SHELL_VALIDATION_FAILED:
      return { ...state, passwordValidationFailed: action.data };
    case Constants.SHELL_RULES_CHECKBOX_STATE:
      return { ...state, isPasswordRulesCheckboxChecked: action.payload };
    case Constants.NON_VZ_CHECKBOX_VALUE:
      return { ...state, isNonVzConsentCheckboxChecked: action.payload };
    case Constants.SHOW_TERMS_AND_CONDITIONS_BANNER:
      return { ...state, showTermsandConditionsBanner: action.payload };
    case Constants.SHOW_EMAIL_EXIST_BANNER:
      return { ...state, showEmailExistBanner: action.payload };
    case Constants.STORE_PREVIOUS_EMAIL:
      return { ...state, previousEmail: action.payload };
    case Constants.TOGGLE_UNIVERSAL_PROFILE_BANNER_DISPLAYED:
      return { ...state, isUniversalProfileSuccessBannerDisplayed: false, universalProfileCreationStatus: '' };
    case Constants.STORE_BLACK_LISTED_DETAILS:
      return { ...state, blackListedPasswordDetails: { ...action.payload } };
    case Constants.STORE_CRADLE_RESPONSE:
      return { ...state, isCradleSuccess: action.payload };

    case 'SHELL_CODE':
      return { ...state, password: action.data };
    case Constants.SEQ_UPDATE_PERSONAL_INFO_COMPLETED:
      return { ...state, isSeqUPICompleted: action.data };
    case Constants.IS_CONTACT_INFO_EDITED:
      return { ...state, isConInfoEdited: action.data };
    case Constants.STORE_CRADLE_THROTTLE_LIST:
      return { ...state, cradleThrottleList: action.payload };
    case Constants.LATEST_SUCCESSFULLY_VERIFIED_EMAIL:
      return { ...state, latestSuccessfullyVerifiedEmail: action.payload };
    // case 'DISABLE_CHECKOUT': {
    //   return { ...state, cartContactCTADisabled: action.payload };
    // }
    default:
      return state;
  }
}

export default contactInfo;
